var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { fetchProductById } from "../../redux/productsReducer";
import { store } from "../../redux/store";
import { SelectorController } from "./controllers/selector-controller";
import { addCartItem } from "../../redux/cartReducer";
import { BasePage } from "./BasePage";
import { property } from "lit/decorators/property.js";
export let ProductDetailPage = class ProductDetailPage extends BasePage {
    constructor() {
        super(...arguments);
        this.productId = "";
        this.sc = new SelectorController(this, store, (state) => state);
    }
    connectedCallback() {
        super.connectedCallback();
        store.dispatch(fetchProductById(this.productId));
    }
    async onAddToCartButton(event) {
        console.log(event);
        const { data: productsByIds } = this.sc?.selected?.products?.productByIds;
        const productDetail = productsByIds?.[this.productId];
        const item = {
            id: productDetail.id,
            title: productDetail.title,
            price: productDetail.price,
            quantity: 1,
        };
        await store.dispatch(addCartItem(item));
        this.shadowRoot.querySelector('#carttoastnotification')?.show("Successfully added item in the cart", 6000);
    }
    render() {
        const { data: productsByIds } = this.sc?.selected?.products?.productByIds;
        const productDetail = productsByIds?.[this.productId];
        return html `<pf-card id="productlist" rounded>
      <img
        slot="header"
        src=${productDetail?.image}
        alt=${productDetail?.title}
        height="100px"
        width="100px"
      />
      <p>
        <a href=${`/products/${productDetail?.id}`}>${productDetail?.title}</a>
      </p>
      <div slot="footer">₹${productDetail?.price}</div>
      <pf-button @click="${this.onAddToCartButton}">Add to cart</pf-button>
    </pf-card> <toast-notification id="carttoastnotification"></toast-notification>`;
    }
};
ProductDetailPage.styles = [...BasePage.styles];
__decorate([
    property({ reflect: true })
], ProductDetailPage.prototype, "productId", void 0);
ProductDetailPage = __decorate([
    customElement("product-detail")
], ProductDetailPage);
